
import { reactive, defineComponent } from 'vue'
import HeadingLv2 from '@/components/elements/HeadingLv2.vue'
import FlowRegister from '@/components/block/FlowRegister.vue'
import RegisterIntro from '@/components/block/RegisterIntro.vue'
import { RegisterUser } from '@/types/RegisterUser'
import { useRoute } from 'vue-router'

export default defineComponent({
  name: 'Regist',

  components: {
    HeadingLv2,
    FlowRegister,
    RegisterIntro
  },

  setup() {
    const state = reactive({
      currentFlow: 1,
      isLandingInput: false
    })

    const data = reactive<RegisterUser>({
      memberType: '',
      hopePrefectures: [],
      hopeKeywords: [],
      userProfile: {
        name_sei: '',
        name_mei: '',
        kana_sei: '',
        kana_mei: '',
        gender: '',
        birthday: '',
        email: '',
        email_confirmation: '',
        isEqualHolidayAddress: true,
        zip: '',
        prefecture: '',
        city: '',
        town: '',
        tel: '',
        zip_vacation: '',
        prefecture_vacation: '',
        city_vacation: '',
        town_vacation: '',
        school_id: '',
        graduate_year: '',
        licensing_year: '',
        work_place: '',
        hoped_departments: ['', '', ''],
        password: '',
        password_confirmation: '',
        socialplus_id: ''
      },
      query: '',
      invitationCode: ''
    })

    const updateFlow = (value: number) => {
      state.currentFlow = value
    }

    const updateMemberType = (value: string) => {
      data.memberType = value
    }

    const updateKeywordsLine = (value: Array<string>) => {
      data.hopeKeywords = value
    }

    const updatePrefecturesLine = (value: Array<string>) => {
      data.hopePrefectures = value
    }

    const updateKeywords = (keyword: any) => {
      const arr = data.hopeKeywords

      if (keyword.checked && arr.indexOf(keyword.value) === -1) {
        arr.push(keyword.value)
      }

      if (!keyword.checked && arr.indexOf(keyword.value) > -1) {
        arr.splice(arr.indexOf(keyword.value), 1)
      }
    }

    const updatepPefectures = (prefectures: any) => {
      const arr = data.hopePrefectures

      if (prefectures.checked && arr.indexOf(prefectures.value) === -1) {
        arr.push(prefectures.value)
      }

      if (!prefectures.checked && arr.indexOf(prefectures.value) > -1) {
        arr.splice(arr.indexOf(prefectures.value), 1)
      }
    }

    const updateProfile = (name: string, value: string) => {
      // 希望科目の場合
      if (name.indexOf('hoped_departments') === 0) {
        const key = name.substr(-2)
        data.userProfile.hoped_departments[Number(key) - 1] = value
        return
      }

      // 希望科目以外
      data.userProfile[name] = value
    }

    const updateLandingState = (value: boolean) => {
      state.isLandingInput = value
    }

    const setInvitationCode = (value: string) => {
      data.invitationCode = value
    }

    const route = useRoute()
    if (Object.keys(route.query).length && route.query.q) {
      data.query = String(route.query.q)
    }

    return {
      state,
      data,
      updateFlow,
      updateMemberType,
      updateKeywords,
      updatepPefectures,
      updateProfile,
      updateKeywordsLine,
      updatePrefecturesLine,
      updateLandingState,
      setInvitationCode
    }
  }
})
